/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation LBRRoutePlanCreateMutation($input: [LBRRoutePlanCreateInput!]!) {
  LBRRoutePlanCreate(input: $input) {
    id,
    message
    status
  }
}
`
